import { IconButton, TextField } from "@mui/material";
import { useState } from "react";
import styles from "./Bot.module.scss";
import FaqContent from "./FaqContent";
import searchIcon from "../../assets/searchIcon.svg";

const FaqBody = () => {
  const [searchQuery, setSearchQuery] = useState(""); // State to store the search query

  // Handle search input change
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  // Filter the questions based on the search query
  const filteredQuestions = questions.filter((item) =>
    item.question.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <div className={styles.faqHeaderContainer}>
        <div className={styles.faqHeader}>Hi there 👋🏼</div>
        <TextField
          placeholder="Search for help"
          fullWidth
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: (
              <IconButton
                aria-label="toggle password visibility"
                edge="end"
                style={{ marginRight: "4px" }}
              >
                <img src={searchIcon} />
              </IconButton>
            ),
          }}
        />
      </div>
      <div className={styles.faqContentContainer}>
        {filteredQuestions.length > 0 ? (
          filteredQuestions.map((item, idx) => (
            <>
              <FaqContent
                key={idx}
                question={item.question}
                answer={item.answer}
              />
              {filteredQuestions.length > idx + 1 && (
                <div className={styles.faqDivider}>
                  <br />
                </div>
              )}
            </>
          ))
        ) : (
          <div>No results found.</div> // Message when no results match the search query
        )}
      </div>
    </>
  );
};

export default FaqBody;

const questions = [
  {
    question: "How do I post a job on Forsatak?",
    answer:
      "Posting a job is easy! Simply create an account, add your job details including description, skills required, and desired qualifications. Then, use your credits to activate the job posting.",
  },
  {
    question:
      "Can I search for Emiratis with specific skills or specific location?",
    answer:
      "Yes, the platform allows employers to search for Emirati candidates based on skills, experience, and location to find the best match for their requirements.",
  },
  {
    question:
      "Can we have multiple users within our organization use the Forsatak platform?",
    answer:
      "Yes, Forsatak supports multiple users from the same organization, allowing teams to collaborate on recruitment.",
  },
  {
    question: "Is there a free trial?",
    answer: "Yes, upon signing up, you’ll get a 15-day free trial.",
  },
  {
    question: "What is the price?",
    answer:
      "Pricing depends on the services and recruitment solutions you choose. Once you sign up our team will be in contact with you for detailed pricing information.",
  },
  {
    question: "Can you run the recruitment process?",
    answer:
      "Yes, Forsatak, in partnership with TASC, offers end-to-end recruitment solutions, including candidate screening, interviews, and hiring support.",
  },
  {
    question: "What is the relation between TASC and Forsatak?",
    answer:
      "Forsatak is powered by TASC, a leading workforce solutions provider in the UAE, ensuring high-quality recruitment services.",
  },
];
